#include <dithering_fragment>
float h = uHeatFallof;

vec4 hard = gl_FragColor * hardenedColor;
gl_FragColor = mix(gl_FragColor, hard, clamp(vColor * 4., 0., 1.) * uHardened);
// gl_FragColor = gl_FragColor + vColor * middleColor * uHeat;
vec4 glow =  vColor * middleColor * uHeat * 2.;
gl_FragColor = mix(gl_FragColor, gl_FragColor * 0.7 + glow , glow.r);